import { Controller } from "stimulus";
import hideElement from "../../functions/hideElement";
import showElement from "../../functions/showElement";

export default class extends Controller {
  static get targets() {
    return ["textContainer", "revealButton", "hideButton"];
  }

  connect() {
    this.PLACEHOLDER = "*";
    this.initialValue = this.textContainerTarget.innerHTML;
    this.toggleText();
  }

  toggleText() {
    if (this.initialValue === this.textContainerTarget.innerHTML) {
      this.textContainerTarget.innerHTML = this.placeholder;
      showElement(this.revealButtonTarget);
      hideElement(this.hideButtonTarget);
    } else {
      this.textContainerTarget.innerHTML = this.initialValue;
      showElement(this.hideButtonTarget);
      hideElement(this.revealButtonTarget);
    }
  }

  get placeholder() {
    return this.PLACEHOLDER.repeat(this.initialValue.length);
  }
}
